import React from "react";
import { useNavigate } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

export default function StoricoOrdini() {
  const nav = useNavigate();

  return (
    <div className="container mt-4">
      <TornaAlMenu to="/" />

      <h2 className="mb-4">📚 Storico ordini</h2>

      <div className="row g-3">
        <div className="col-12 col-md-6">
          <div
            className="card shadow-sm h-100"
            role="button"
            onClick={() => nav("/ordini/miei?view=storico&from=storico")}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Storico</div>
                <div className="fw-bold fs-5">Ordini inviati alla Sede →</div>
                <div className="small text-muted mt-1">Tutti gli ordini che hai inviato alla Sede.</div>
              </div>
              <div style={{ fontSize: 42 }}>🧾</div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div
            className="card shadow-sm h-100"
            role="button"
            onClick={() => nav("/ordini/ricevuti?view=all&from=storico")}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Storico</div>
                <div className="fw-bold fs-5">Ordini ricevuti →</div>
                <div className="small text-muted mt-1">Tutti gli ordini ricevuti da aziende/clienti collegati.</div>
              </div>
              <div style={{ fontSize: 42 }}>📦</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
